/** "Buy 1 Get 1 free — you save ₹500", or the nudge "Add 1 more eligible item to get …". */
export const OfferNotice = ({ offer, fmt, className = '' }) => {
  if (!offer) return null;
  if (offer.valid) {
    return (
      <div className={`flex items-center gap-2 rounded-xl bg-primary text-white px-4 py-2.5 text-sm ${className}`} role="status">
        <span aria-hidden="true">🎁</span>
        <p><span className="font-semibold">{offer.title}</span> applied · you save {fmt(offer.discount)}</p>
      </div>
    );
  }
  if (!offer.message) return null;
  return (
    <div className={`flex items-center gap-2 rounded-xl bg-primary-light text-primary px-4 py-2.5 text-sm ${className}`} role="status">
      <span aria-hidden="true">🎁</span>
      <p>{offer.message}</p>
    </div>
  );
};

/** Under a cart line: "1 FREE" or "Offer −₹250". */
export const OfferItemTag = ({ line, unitPrice, fmt }) => {
  if (!line) return null;
  const allFree = line.discount >= line.discountedQuantity * Number(unitPrice) - 0.01;
  return (
    <span className="inline-block mt-1 rounded-full bg-emerald-100 text-emerald-700 text-[10px] font-bold px-2 py-0.5">
      {allFree ? `${line.discountedQuantity} FREE` : `Offer −${fmt(line.discount)}`}
    </span>
  );
};
